var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ot-input',{attrs:{"type":"checkboxgroup","options":_vm.options,"value":_vm.checked},on:{"input":_vm.onInputChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }